import { useEffect, useState } from 'react'
import { fetchOperators } from '../api/catalog'

/**
 * Blocco 1 / Card D — formattazione condivisa dalle pagine di amministrazione avanzata. Un importo assente (chiave non
 * inviata dal server a chi non ha `CanSeeRealAmounts`) si mostra sempre come "—", mai come 0.
 */
export function eur(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—'
  return '€ ' + n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function num(n: number | null | undefined, digits = 0): string {
  if (n === null || n === undefined) return '—'
  return n.toLocaleString('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export function pct(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—'
  return `${n.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`
}

export function dateIt(s?: string | null): string {
  if (!s) return '—'
  return new Date(s.length === 10 ? `${s}T12:00:00` : s).toLocaleDateString('it-IT')
}

export function shortDate(s: string): string {
  const [, m, d] = s.slice(0, 10).split('-')
  return `${d}/${m}`
}

export function errMsg(e: unknown, fallback: string): string {
  return e instanceof Error ? e.message : fallback
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

const MONTHS = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
export function monthLabel(year: number, month: number): string {
  return `${MONTHS[month - 1] ?? month} ${year}`
}

/** Mappa id -> nome degli operatori commerciali (per le tabelle che ricevono solo l'id). */
export function useOperatorNames(): Map<number, string> {
  const [names, setNames] = useState<Map<number, string>>(new Map())
  useEffect(() => {
    let alive = true
    void fetchOperators().then(r => { if (alive) setNames(new Map(r.items.map(o => [o.id, o.name]))) }).catch(() => undefined)
    return () => { alive = false }
  }, [])
  return names
}
